module.exports = __webpack_public_path__ + "static/coaching_oben_cropped-43c2c81165897441730d8ad059f7781a.jpg";